<main class="nf-root" role="main" aria-labelledby="nf-title">
  <section class="nf-card">
    <div class="nf-visual">
      <svg class="nf-planet" viewBox="0 0 200 200" aria-hidden="true">
        <defs>
          <linearGradient id="g1" x1="0%" x2="100%">
            <stop offset="0%" stop-color="#6EE7B7" />
            <stop offset="100%" stop-color="#3B82F6" />
          </linearGradient>
        </defs>
        <circle cx="100" cy="100" r="60" fill="url(#g1)" />
        <g class="nf-orbit">
          <circle cx="155" cy="45" r="6" fill="#fff" />
          <ellipse cx="100" cy="100" rx="85" ry="30" fill="none" stroke="#ffffff33" stroke-width="2" />
        </g>
      </svg>


      <div class="nf-404" aria-hidden="true">
        <span>4</span>
        <span class="nf-zero">0</span>
        <span>4</span>
      </div>
    </div>


    <div class="nf-content">
      <h1 id="nf-title">صفحه موردنظر پیدا نشد</h1>
      <p>ممکن است لینک اشتباه باشد یا صفحه حذف شده باشد. می‌توانید از دکمه زیر بازگردید یا در سایت جستجو کنید.</p>


      <div class="nf-actions">
        <button class="btn btn-primary" (click)="goHome()" aria-label="بازگشت به صفحه اصلی">بازگشت به صفحه اصلی</button>


      </div>

    </div>
  </section>


  <div class="nf-footer" aria-hidden="true">
    <div class="plane" role="img" aria-label="انیمیشن هواپیما">
      <svg viewBox="0 0 24 24">
        <path d="M2 21l21-9L2 3l5 7-5 3 5 2z" fill="currentColor" />
      </svg>
    </div>
  </div>
</main>
